import { createAction } from 'redux-actions';

export default {
    UpdateCondition: createAction('UPDATE_CONDITION')
};
